<ng-container *transloco="let _t">

<div class="wrapper" [ngClass]="{'down': uploadable}" >
<img [src]="src" alt="" [id]="uniqID" *ngIf="src!=undefined"
	[ngClass]="{'zoomed': zoomed}" 
	(load)="autosize($event)" (click)="resize()" >
</div>
<a id="delete" (click)="delete()"  *ngIf="src!=undefined && uploadable"
	[title]="_t('cmat-picture-title-0')">
	<mat-icon>delete_forever</mat-icon>
</a>

<ng4-files-drop *ngIf="uploadable" (filesSelect)="filesSelect($event);" [configId]="'my-image-config'">
	<legend>{{alt}}</legend>
  	<ng4-files-click  *ngIf="!showSpinner" 
  		(filesSelect)="filesSelect($event)" 
  		[configId]="'my-image-config'">
	    <span>{{ _t('cmat-picture-span-0') }}</span>
	</ng4-files-click>
</ng4-files-drop>

<div class="spin" *ngIf="showSpinner">
<mat-progress-spinner
	[diameter]="100"
	[mode]="'indeterminate'"
	>
</mat-progress-spinner>
</div>



<div class="overlay" *ngIf="fullsize"
	(click)="resize()">
	<img [src]="src" alt="" *ngIf="src!=undefined">
</div>

</ng-container>